import React, {useState} from "react";
import authAxios from "../api/axios";
import {
    fnDeleteSubjectID,
    fnDeleteSubjectIDNoRedirect,
    fnFetchAllSubject,
    fnFetchSubjectID,
    fnModifyAsyncNoRedirect,
    fnModifyAsyncRedirect, fnPostAsyncRedirect,
    fnPostToSubject,
} from "./CrudContextProviderUtil";

export const WorkOrderDataContext = React.createContext();

// Special Edge Case for mass job
export const fnMassJobCreateSubject = (
    axiosObj,
    path,
    errorStateSetter = function (e) {
        console.log(e);
    }
) => {
    return (navigate, postObject) => {
        axiosObj
            .post(`/api/${path}`, postObject)
            .then((res) => {
                if(res.status !== 500) {
                    navigate("/workorders");                
                }
            })
            .catch((err) => errorStateSetter(err));
    };
};

export default function UserDataProvider(props) {
    const [isLoading, setIsLoading] = useState(false);
    return (
        <WorkOrderDataContext.Provider
            value={{
                modifyWorkOrderAsync: fnModifyAsyncRedirect(authAxios, "workorder", function(){}, setIsLoading),
                modifyWorkOrderAsyncNoRedirect: fnModifyAsyncNoRedirect(authAxios, "workorder", function(){}, setIsLoading),
                fetchAllWorkOrderAsync: fnFetchAllSubject(authAxios, "workorder", function(){}, setIsLoading),
                fetchWorkOrderAsync: fnFetchSubjectID(authAxios, "workorder", function(){}, setIsLoading),
                fetchWorkOrderAsyncNoAdvance: fnFetchSubjectID(authAxios, "workorder/noadvance", function(){}, setIsLoading),
                postWorkOrderAsync: fnPostToSubject(authAxios, "workorder", function(){}, setIsLoading),
                fetchAllLocationAsync: fnFetchAllSubject(authAxios, "location", function(){}, setIsLoading),
                fetchAllWorkOrderNotesAsync: fnFetchSubjectID(authAxios, "workorder/note", function(){}, setIsLoading),
                postWorkOrderCommentAsync: fnPostToSubject(authAxios, "workorder/note", function(){}, setIsLoading),
                editWorkOrderCommentAsync: fnModifyAsyncNoRedirect(authAxios, "workorder/note", function(){}, setIsLoading),
                deleteWorkOrderCommentAsync: fnDeleteSubjectIDNoRedirect(authAxios, "workorder/note", function(){}, setIsLoading),
                fetchAllWorkOrderAssignmentAsync: fnFetchSubjectID(authAxios, "workorderassignment/getuser", function(){}, setIsLoading),
                deleteWorkOrderAssignmentAsyncNoRedirect: fnDeleteSubjectIDNoRedirect(authAxios, "workorderassignment", function(){}, setIsLoading),
                modifyWorkOrderAssignmentAsyncNoRedirect: fnModifyAsyncNoRedirect(authAxios, "workorderassignment", function(){}, setIsLoading),
                postWorkOrderAssignmentAsync: fnPostToSubject(authAxios, "workorderassignment", function(){}, setIsLoading),
                fetchAllUsersAsync: fnFetchAllSubject(authAxios, "user", function(){}, setIsLoading),
                fetchAllPartsAsync: fnFetchAllSubject(authAxios, "part", function(){}, setIsLoading),
                fetchPartsWorkOrderAsync: fnFetchSubjectID(authAxios, "mapPartWorkOrder/workorder", function(){}, setIsLoading),
                postPartsWorkOrderAsync: fnPostToSubject(authAxios, "mapPartWorkOrder", function(){}, setIsLoading),
                modifyPartsWorkOrderAsyncNoRedirect: fnModifyAsyncNoRedirect(authAxios, "mapPartWorkOrder", function(){}, setIsLoading),
                deletePartsWorkOrderAsyncNoRedirect: fnDeleteSubjectIDNoRedirect(authAxios, "mapPartWorkOrder", function(){}, setIsLoading),
                fetchAllWorkOrdersTodayUser: fnFetchSubjectID(authAxios, "workorder/user/today", function(){}, setIsLoading),
                postNewMassJobCreate: fnMassJobCreateSubject(authAxios, "utils/mass-create-workorders", function(){}, setIsLoading),
                fnDeleteSubjectID: fnDeleteSubjectID(authAxios, "workorder", function(){}, setIsLoading),
                isLoading,
                postNewWorkOrderRedirect: fnPostAsyncRedirect(authAxios, "workorder")
            }}
        >
            {props.children}
        </WorkOrderDataContext.Provider>
    );
}
